angular.module( 'acme.view.application.users.schedule', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.users.schedule.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var usersSchedule = {
        name: 'application.users.schedule',
        url: '/:id/schedule',
        views: {
          "subview-main": {
            controller: 'UsersScheduleController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/users/schedule/schedule.tpl.html'
          }
        },
        data: {
          pageTitle: 'User Schedule',
          permissions: ['USERS_SCHEDULE_VIEW']
        },
        resolve: {
          jqueryUI: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/jquery-ui.custom.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;

          }],
          fullcalendar: ['$q', '$rootScope', function($q, $rootScope) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/fullcalendar.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;

          }]
        }
      };

    $stateProvider
      .state(usersSchedule);
});
